import { api } from "../_services/api";
export const userActions = {
  login(data) {
    return (dispatch, getState) => {
      dispatch({
        type: "LOGIN_START",
      });
      api.login(data).then(
        (res) => {
          res.json().then((json) => {
            dispatch({
              type: data.type.toUpperCase() + "_SUCCESS",
              data: json,
            });
          });
        },
        (err) => {
          dispatch({
            type: data.type.toUpperCase() + "_FAIL",
            data: err,
          });
        },
      );
    };
  },
};
